import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { Iterable } from 'immutable';
import makeRootReducer from 'common/reducers';
import { routerMiddleware } from 'react-router-redux';

const stateTransformer = state => {
  let newState = {};

  for (var i of Object.keys(state)) {
    if (Iterable.isIterable(state[i])) {
      newState[i] = state[i].toJS();
    } else {
      newState[i] = state[i];
    }
  }

  return newState;
};

export default function configureStore(history, initialState = {}) {
  const middleware = [thunk];
  const enhancers = [];
  if (process.env.NODE_ENV !== 'production') {
    const devToolsExtension = window.devToolsExtension;
    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }

    // Adding logger to middleware
    const createLogger = require('redux-logger');
    const logger = createLogger({
      collapsed: true,
      stateTransformer,
    });

    middleware.push(logger);
  }

  // Adding redux-router support after logging one
  if (history) {
    middleware.push(routerMiddleware(history));
  }

  const store = createStore(
    makeRootReducer(),
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  if (module.hot) {
    module.hot.accept('common/reducers', () => {
      const nextRootReducer = require('common/reducers').default;

      store.replaceReducer(nextRootReducer());
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/modules/common/redux/configureStore.js